import { j as e } from "../../../../jsx-runtime.BREq8dyb.js";
import { DataImportExportStatus as o } from "@decentriq/graphql/dist/enums";
import { faCircleCheck as h, faCircleXmark as C } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as f } from "@fortawesome/react-fontawesome";
import { styled as u, useTheme as j, DialogContent as w, Stack as y, Box as a, Typography as r, CircularProgress as I } from "@mui/joy";
import * as l from "react";
import { memo as M, Fragment as c } from "react";
import { S as i } from "../../../../index.B-E4PB3F.js";
import S, { DqDatasetSyncIconSize as H } from "../DqDatasetSyncIcon/DqDatasetSyncIcon.js";
const v = (t) => /* @__PURE__ */ l.createElement("svg", { width: 72, height: 39, viewBox: "0 0 72 39", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ l.createElement("path", { d: "M71.9862 1.68678C71.9862 1.28923 71.6685 0.968219 71.2751 0.968219H36.2061C36.1346 0.944834 36.0609 0.927826 35.981 0.927826H0.724729C0.331333 0.927826 0.0136719 1.24884 0.0136719 1.64639V37.3536C0.0136719 37.7512 0.331333 38.0722 0.724729 38.0722H35.981C36.0693 38.0722 36.1556 38.053 36.2334 38.0233H71.2751C71.4623 38.0254 71.6432 37.9531 71.7779 37.8213C71.8999 37.6959 71.9651 37.5386 71.9777 37.3749C71.9777 37.3536 71.984 37.3345 71.984 37.3111V1.68678H71.9862ZM67.0887 32.0728C68.5445 30.4847 69.7268 28.6373 70.564 26.6091V35.5785L67.0887 32.0728ZM60.0055 24.9275C59.7278 24.6469 59.2755 24.6469 58.9978 24.9275C58.7201 25.2081 58.7201 25.6652 58.9978 25.9458L65.0796 32.077C62.0692 34.8748 58.0532 36.5861 53.6396 36.5861C44.3033 36.5861 36.7341 28.937 36.7341 19.5021C36.7341 10.0672 44.3033 2.41811 53.6396 2.41811V2.42448C62.9696 2.43511 70.5325 10.0757 70.5451 19.5043C70.5451 23.9623 68.8537 28.0229 66.0852 31.0651L60.0055 24.9318V24.9275ZM70.5619 12.376C68.7065 7.87964 65.1491 4.28255 60.7018 2.40323H70.5619V12.376ZM46.5753 2.40323C42.1407 4.27618 38.5896 7.8605 36.7299 12.3399V2.40323H46.5753ZM35.2678 12.2676C33.3871 7.79247 29.8171 4.2209 25.3656 2.36283H35.2678V12.2676ZM1.43579 2.36496H18.1435C18.2151 2.38834 18.2887 2.40535 18.3686 2.40535C27.3852 2.40535 34.7545 9.52936 35.2699 18.5114V20.5183C34.7545 29.5004 27.3873 36.6244 18.3686 36.6244C18.3392 36.6244 18.3118 36.6287 18.2845 36.6329H1.43579V2.36496ZM25.4434 36.635C29.8592 34.7685 33.3976 31.2118 35.2678 26.7622V36.635H25.4434ZM36.732 36.5861V26.6602C38.5875 31.131 42.128 34.7089 46.5501 36.5861H36.732ZM66.0852 33.089L69.5543 36.5861H60.7165C62.7087 35.74 64.5222 34.5495 66.0852 33.089Z", fill: "black" })), V = (t) => /* @__PURE__ */ l.createElement("svg", { width: 48, height: 15, viewBox: "0 0 48 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ l.createElement("path", { d: "M47.2071 8.20711C47.5976 7.81658 47.5976 7.18342 47.2071 6.79289L40.8431 0.428932C40.4526 0.0384078 39.8195 0.0384078 39.4289 0.428932C39.0384 0.819457 39.0384 1.45262 39.4289 1.84315L45.0858 7.5L39.4289 13.1569C39.0384 13.5474 39.0384 14.1805 39.4289 14.5711C39.8195 14.9616 40.4526 14.9616 40.8431 14.5711L47.2071 8.20711ZM0.5 8.5H46.5V6.5H0.5V8.5Z", fill: "black" })), d = u(f)({
  background: "white",
  left: 0,
  margin: "auto",
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translateY(-50%)"
}), D = M(({
  error: t = "",
  isImportExportCreated: g,
  result: m,
  status: s = o.Pending,
  syncDirection: n,
  syncType: p
}) => {
  const {
    palette: x
  } = j();
  return /* @__PURE__ */ e.jsx(w, { children: /* @__PURE__ */ e.jsxs(y, { children: [
    /* @__PURE__ */ e.jsxs(a, { sx: {
      alignItems: "center",
      display: "flex",
      flexDirection: n === i.IMPORT ? "row" : "row-reverse",
      justifyContent: "center"
    }, children: [
      /* @__PURE__ */ e.jsx(S, { size: H.lg, syncType: p }),
      /* @__PURE__ */ e.jsxs(a, { sx: {
        alignItems: "center",
        display: "flex",
        ml: 1,
        mr: 1,
        position: "relative"
      }, children: [
        /* @__PURE__ */ e.jsx(V, {}),
        s === o.Success && /* @__PURE__ */ e.jsx(d, { color: x.primary[500], icon: h, size: "lg" }),
        (s === o.Failed || t) && /* @__PURE__ */ e.jsx(d, { color: x.danger[500], icon: C, size: "lg" })
      ] }),
      /* @__PURE__ */ e.jsx(v, {})
    ] }),
    /* @__PURE__ */ e.jsxs(a, { sx: {
      display: "flex",
      flexDirection: "column",
      margin: "0 auto",
      textWrap: "balance",
      width: "75%"
    }, children: [
      s === o.Pending && !t && /* @__PURE__ */ e.jsxs(c, { children: [
        /* @__PURE__ */ e.jsxs(r, { gutterBottom: !0, sx: {
          alignItems: "center",
          display: "inline-flex",
          justifyContent: "center"
        }, children: [
          /* @__PURE__ */ e.jsx(I, { sx: {
            "--CircularProgress-size": "24px",
            mr: 1
          } }),
          n === i.IMPORT ? "Importing" : "Exporting",
          " ",
          "in progress..."
        ] }),
        /* @__PURE__ */ e.jsx(r, { level: "body-sm", textAlign: "center", children: g ? 'You can close this window and check the status in the Datasets page "Imports/Exports" tab.' : "Connecting to external source. Please don't close this window yet." })
      ] }),
      s === o.Success && /* @__PURE__ */ e.jsxs(c, { children: [
        /* @__PURE__ */ e.jsxs(r, { gutterBottom: !0, textAlign: "center", children: [
          n === i.IMPORT ? "Importing" : "Exporting",
          " ",
          "has completed"
        ] }),
        /* @__PURE__ */ e.jsx(r, { level: "body-sm", textAlign: "center", children: n === i.IMPORT ? "Your dataset is ready to be provisioned to data clean rooms." : "Your dataset is ready to be used on the chosen destination" })
      ] }),
      (s === o.Failed || t) && /* @__PURE__ */ e.jsxs(c, { children: [
        /* @__PURE__ */ e.jsxs(r, { gutterBottom: !0, textAlign: "center", children: [
          n === i.IMPORT ? "Importing" : "Exporting",
          " ",
          "did not complete"
        ] }),
        (m?.error || t) && /* @__PURE__ */ e.jsxs(r, { level: "body-sm", textAlign: "center", children: [
          /* @__PURE__ */ e.jsx("span", { children: "Error:" }),
          " ",
          m?.error || t
        ] })
      ] })
    ] })
  ] }) });
});
D.displayName = "DqDatasetSyncStatus";
export {
  D as default
};
//# sourceMappingURL=DqDatasetSyncStatus.js.map
